export default __webpack_public_path__ + "alberta-euro.5d71bfe67dd60ad3d264.svg";